/* globals window */

import getObjectProperty from './getObjectProperty';

/**
 * Returns the translation for the given path
 * @param {String} path
 * @param {Object} args
 * @return {String}
 */
const trans = (path, args = {}) => {
  let translation = getObjectProperty(window.appTranslations, path, path);

  Object.keys(args).forEach((key) => {
    const regex = new RegExp(`:(${key})`, 'g');
    translation = translation.replace(regex, args[key]);
  });

  return translation;
};

export default trans;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/trans.js